export const autoBrandDiscard = 'auto-brand-discard-modal';
export const autoBrandModal = 'auto-brand-modal';

export const autoBrandModalsIds = [autoBrandModal, autoBrandDiscard];
